import { Switch, Route, Redirect } from "react-router-dom";
import React, { useState } from "react";
import 'semantic-ui-css/semantic.min.css'
import "animate.css/animate.min.css";


// COMPONENTS PAGES
import Home from './components/Pages/Home';
import Baby from './components/Pages/Baby';
import Birthday from './components/Pages/Birthday';
import Weeding from './components/Pages/Weeding';
import Mignardise from "./components/Pages/Mignardise";

// import Faq from './components/Pages/Faq';
import Contact from './components/Pages/Contact';
// PAGE 404
import NoMatch from './components/Pages/NoMatch';

import Formation from './components/Pages/Formation';


// COMPONENTS SIMPLE
import Nav from './components/Nav';
import Navscreen from './components/Nav/navScreen';

import ModalExampleContentImage from './components/Modal';


import ScrollToTop from './components/ScrollToTop'

import './App.css';
import Footer from "./components/Footer";
import Tarifs from "./components/Pages/Tarifs";

function App() {

  const [openMenu, setOpenMenu] = useState(false);

  const openBurger = () => {
    setOpenMenu(!openMenu)
  }


  return (
    <div className="App" >
    <ScrollToTop />
      <div className="screen">
        <Navscreen />
      </div>
      <div className="phone">
        {openMenu && <Nav openBurger={openBurger} />}
      </div>
      <Switch>
        <Route exact path="/">
          <Home openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        <Route path="/baby-shower">
          <Baby openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        {/* <Route path="/faq">
            <Faq />
          </Route> */}
        <Route path="/anniversaire">
          <Birthday openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        <Route path="/mariage">
          <Weeding openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        <Route path="/mignardises">
          <Mignardise openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        <Route path="/tarifs">
          <Tarifs openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        <Route path="/formations">
          <Formation openBurger={openBurger} isOpen={openMenu} />
          <ModalExampleContentImage />

        </Route>
        <Route path="/contact">
          <Contact openBurger={openBurger} isOpen={openMenu} />
        </Route>
        <Route path="/*">
          <NoMatch />
        </Route>

        <Redirect from="https://les-delices-de-lylia.netlify.app/formations" to="/formations" />

      </Switch>
      <Footer />
    </div>
  );
}

export default App;